import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'

import { api } from '@/lib/api'
import type { Notification, PageMeta } from '@/lib/types'

interface NotificationList {
  notifications: Notification[]
  unread_count: number
  meta: PageMeta
}

export function useNotifications(page = 1, enabled = true) {
  return useQuery({
    queryKey: ['notifications', page],
    queryFn: () => api.get<NotificationList>('/notifications', { query: { page, per_page: 20 } }),
    // Lonceng notifikasi menyegarkan diri secara berkala. Selang satu menit
    // sudah cukup terasa hidup tanpa membebani server dengan polling rapat.
    refetchInterval: 60_000,
    enabled,
  })
}

export function useMarkNotificationRead() {
  const client = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => api.post<void>(`/notifications/${id}/read`),
    onSuccess: () => client.invalidateQueries({ queryKey: ['notifications'] }),
  })
}

export function useMarkAllNotificationsRead() {
  const client = useQueryClient()

  return useMutation({
    mutationFn: () => api.post<void>('/notifications/read-all'),
    onSuccess: () => client.invalidateQueries({ queryKey: ['notifications'] }),
  })
}
